export default {
    getHeaderBgColor: state => {
        return state.headerBgColor;
    },
    getHeaderTextColor: state => {
        return state.headerTextColor;
    }
}


// WEBPACK FOOTER //
// ./src/_store/modules/skinModule/getters.js